import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VFooter,{attrs:{"padless":"","app":"","color":"grey lighten-3"}},[_c(VCol,{staticClass:"text-center pa-0",attrs:{"cols":"12"}},[_c('small',[_vm._v(" © 2022 Equmenopolis Inc. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }